import { AitRowGroupData } from "aic";
import { IEditorV3 } from "editor-v3";

/**
 * Merges the provided row groups with the parent row groups, ensuring no duplicates.
 *
 * @param rowGroups - The row groups at this level
 * @param parentRowGroups - The higher level row groups
 * @returns The merged row groups
 */
export const getGroupTemplates = (
  rowGroups: AitRowGroupData<IEditorV3>[] = [],
  parentRowGroups: AitRowGroupData<IEditorV3>[] = [],
): AitRowGroupData<IEditorV3>[] => {
  return [
    ...parentRowGroups.filter((group) => !rowGroups.some((g) => g.name === group.name)),
    ...rowGroups,
  ];
};
